import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { IconButton, ListItemIcon, ListItemText } from '@mui/material';
import Iconify from '../Iconify';
import IconAnalitics from 'src/sections/@dashboard/general/analytics/IconAnalitics';

export default function MenuActions({ rows }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton onClick={handleClick}>
        <Iconify
          sx={{ color: 'white' }}
          icon={'eva:more-vertical-fill'}
          width={20}
          height={20}
        />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {rows.map((r) => (
          <MenuItem key={r.text} onClick={r.handler}>
            <ListItemIcon sx={{ minWidth: '5px !important' }}>
              <IconAnalitics icon={r.icon} />
            </ListItemIcon>
            <ListItemText> {r.text}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
